import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import NewProcess from "@/components/Processes/NewProcess.vue";

export const useNewProcessDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();

    const open = () => {
        dialogRef.value = dialog.open(NewProcess, {
            props: {
                header: "New process",
                style: {
                    maxWidth: "700px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
        });
    };

    return {
        open,
        isVisible: computed(() => Boolean(dialogRef.value?.visible)),
    };
};
